import { z } from 'zod'

export const AffiliateCommissionItemSchema = z.object({
  lineKind: z.string(),
  name: z.string(),
  commissionable: z.boolean(),
  targetEnablesAffiliates: z.boolean(),
  commissionsAffiliate: z.boolean(),
  commissionPercentage: z.string().optional(),
  blockedReason: z.string().optional(),
})

export const AffiliateCommissionScopeSchema = z.object({
  productId: z.string(),
  productName: z.string(),
  enablesAffiliates: z.boolean(),
  commissionsFunnel: z.boolean().optional(),
  commissionPercentage: z.string().optional(),
  items: z.array(AffiliateCommissionItemSchema),
})

export type AffiliateCommissionItem = z.infer<typeof AffiliateCommissionItemSchema>
export type AffiliateCommissionScope = z.infer<typeof AffiliateCommissionScopeSchema>
